import TableSalesReportsAccredited from '../tablesalesreportsaccredited/tablesalesreportsaccredited.vue'
export default {
  name: 'BoardSaledReportsAccredited',
  components: {TableSalesReportsAccredited},
  props: ['mes', 'dataEnteprise', 'dataCredenciada', 'i', 'posicaoMes', 'dataSalesProp'],
  mounted () {
    this.dataSales = this.dataSalesProp
    let enterpriseNames = []
    this.dataSales.forEach(sale => {
      if (!enterpriseNames.includes(sale.nomeEmpreendimento)) {
        enterpriseNames.push(sale.nomeEmpreendimento)
      }
    })
    enterpriseNames.forEach(enterpriseName => {
      this.reportEnterprise.push(
        this.dataSales.filter(sale => sale.nomeEmpreendimento === enterpriseName)
      )
    })
  },
  data () {
    return {
      columns: ['VENDAS', 'VALOR', 'QUANTIITEM'],
      changeAngel: false,
      reportEnterprise: [],
      dataSales: []
    }
  },
  watch: {
    dataCredenciada (newvalue, newOld) {
      this.dataforkey = this.dataforkey + this.dataforkey
    }
  },
  methods: {
    SetDataSales (newDataSales) {
      this.dataSales = newDataSales
      if (this.reportEnterprise.length === 0) {
        let enterpriseNames = []
        this.dataSales.forEach(sale => {
          if (!enterpriseNames.includes(sale.nomeEmpreendimento)) {
            enterpriseNames.push(sale.nomeEmpreendimento)
          }
        })
        enterpriseNames.forEach(enterpriseName => {
          this.reportEnterprise.push(
            this.dataSales.filter(sale => sale.nomeEmpreendimento === enterpriseName)
          )
        })
      }
    },
    getDataSales () {
      this.$emit('getDataSales', this.posicaoMes)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesbyaccredited/components/boardsalesreportsaccredited/boardsalesreportsaccredited.js